module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5Qf74"))).then(() => parcelRequire('d0iPb'));